import { useJsonFeatures } from '~map-preview/states/map'
import { getPropertyValues, getPropertyOptionRange } from 'utils'
import _ from 'lodash'

export const useGetOptions = (property: any) => {
  const jsonFeatures = useJsonFeatures()
  const allProperties = getPropertyValues(jsonFeatures, property.name)
  return getPropertyOptionRange(allProperties)
}
